var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      attrs: {
        "grid-list-xl": "",
        "text-center": "",
        role: "region",
        "aria-label": "Complete OAuth profile",
      },
    },
    [
      _c(
        "v-layout",
        { staticClass: "primary", attrs: { wrap: "", role: "presentation" } },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                "offset-lg3": "",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { color: "secondary" } },
                [
                  _c(
                    "v-app-bar",
                    { attrs: { color: "primary", flat: "" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass: "text-body-2",
                          attrs: { role: "heading", "aria-level": "1" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "components.oauthProfile.steppers.setupAccount"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-md": "" } },
                    [
                      _vm._l(_vm.filteredErrors, function (errorsGroup, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            attrs: { role: "alert", "aria-live": "assertive" },
                          },
                          _vm._l(errorsGroup, function (error) {
                            return _c(
                              "v-alert",
                              {
                                key: error.id,
                                attrs: {
                                  type: error.type,
                                  icon: error.icon,
                                  dense: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(error.msg) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                "text-center": "",
                                flex: "",
                                xs12: "",
                                sm8: "",
                                md9: "",
                                "mb-5": "",
                              },
                            },
                            [
                              _vm.downloadGames.length &&
                              _vm.$vuetify.breakpoint.mdAndUp
                                ? _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        bottom: "",
                                        "offset-y": "",
                                        color: "secondary",
                                        role: "menu",
                                        "aria-label": "Game client downloads",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          color: "accent",
                                                          "aria-label":
                                                            "Download game client",
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "components.register.buttons.download"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1436842057
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        { attrs: { role: "menu" } },
                                        _vm._l(
                                          _vm.downloadGames,
                                          function (game) {
                                            return _c(
                                              "v-list-item",
                                              {
                                                key: game.id,
                                                attrs: {
                                                  role: "menuitem",
                                                  link: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goTo(game.link)
                                                  },
                                                },
                                              },
                                              [
                                                game.useImageAsBackground
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "v-list-item-background-image",
                                                        style:
                                                          "background-image: url('" +
                                                          game.img +
                                                          "')",
                                                        attrs: {
                                                          role: "img",
                                                          "aria-label": _vm.$t(
                                                            game.title
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "v-list-item-download-labels",
                                                          },
                                                          [
                                                            game.isNew
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "downloadLabel downloadNew",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "New"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            game.isRecommend
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "downloadLabel downloadRecommend",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Recommend"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            game.isRecommend
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "downloadLabel downloadComingSoon",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Coming Soon"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : [
                                                      _c(
                                                        "v-list-item-avatar",
                                                        {
                                                          attrs: { size: "25" },
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              _vm._s(game.icon)
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "text-no-wrap",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  game.title
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "v-list-item-download-labels",
                                                            },
                                                            [
                                                              game.isNew
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "downloadLabel downloadNew",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "New"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              game.isRecommend
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "downloadLabel downloadRecommend",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Recommend"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              game.isRecommend
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "downloadLabel downloadComingSoon",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Coming Soon"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          staticClass: "alert-discord",
                          attrs: {
                            value: _vm.discordCommunity.enabled,
                            type: _vm.discordCommunity.type,
                            icon: _vm.discordCommunity.icon,
                            role: "link",
                            "aria-label": "Join our Discord community",
                          },
                          on: { click: _vm.onClickDiscordLink },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "components.register.communities.discord"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          staticClass: "alert-discord",
                          attrs: {
                            value: _vm.newbieGift.link,
                            type: _vm.newbieGift.type,
                            icon: _vm.newbieGift.icon,
                            role: "link",
                            "aria-label": _vm.$t(_vm.newbieGift.name),
                          },
                          on: { click: _vm.onClickGiftsLink },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(_vm.newbieGift.name)) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        {
                          attrs: {
                            role: "form",
                            "aria-label": "Set account credentials",
                          },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.validate($event)
                            },
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min:6|max:16",
                                        expression: "'required|min:6|max:16'",
                                      },
                                    ],
                                    attrs: {
                                      "prepend-icon": "fal fa-user",
                                      color: "accent",
                                      "data-vv-name": "username",
                                      "error-messages":
                                        _vm.errors.collect("username"),
                                      label:
                                        _vm.$t(
                                          "components.oauthProfile.form.username"
                                        ) + " *",
                                      autocomplete: "username",
                                      "aria-required": "true",
                                    },
                                    model: {
                                      value: _vm.form.username,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "username", $$v)
                                      },
                                      expression: "form.username",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|email|min:6|max:255",
                                        expression:
                                          "'required|email|min:6|max:255'",
                                      },
                                    ],
                                    attrs: {
                                      "prepend-icon": "fal fa-envelope",
                                      color: "accent",
                                      "data-vv-name": "email",
                                      "error-messages":
                                        _vm.errors.collect("email"),
                                      label:
                                        _vm.$t(
                                          "components.oauthProfile.form.email"
                                        ) + " *",
                                      autocomplete: "email",
                                      "aria-required": "true",
                                    },
                                    model: {
                                      value: _vm.form.email,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "email", $$v)
                                      },
                                      expression: "form.email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min:6|max:50",
                                        expression: "'required|min:6|max:50'",
                                      },
                                    ],
                                    ref: "password",
                                    attrs: {
                                      "prepend-icon": "fal fa-key",
                                      color: "accent",
                                      "data-vv-name": "password",
                                      "error-messages":
                                        _vm.errors.collect("password"),
                                      label:
                                        _vm.$t(
                                          "components.oauthProfile.form.password"
                                        ) + " *",
                                      type: "password",
                                      autocomplete: "new-password",
                                      "aria-required": "true",
                                    },
                                    model: {
                                      value: _vm.form.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "password", $$v)
                                      },
                                      expression: "form.password",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "required|min:6|max:50|confirmed:password",
                                        expression:
                                          "'required|min:6|max:50|confirmed:password'",
                                      },
                                    ],
                                    attrs: {
                                      "prepend-icon": "fal fa-key",
                                      color: "accent",
                                      "data-vv-name": "confirmPassword",
                                      "error-messages":
                                        _vm.errors.collect("confirmPassword"),
                                      label:
                                        _vm.$t(
                                          "components.oauthProfile.form.confirmPass"
                                        ) + " *",
                                      type: "password",
                                      autocomplete: "new-password",
                                      "aria-required": "true",
                                    },
                                    model: {
                                      value: _vm.form.confirmPassword,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "confirmPassword",
                                          $$v
                                        )
                                      },
                                      expression: "form.confirmPassword",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      color: "accent",
                                      "aria-checked": _vm.form.acceptedTerms,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "components.register.form.acceptTerms"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function (ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "a",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "register-important-link",
                                                                  attrs: {
                                                                    target:
                                                                      "_blank",
                                                                    href: _vm.toTCLink,
                                                                    "aria-label":
                                                                      "Read Terms and Conditions",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                      },
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  "\n                            Learn More\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "components.register.form.acceptTermsDialog"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.form.acceptedTerms,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "acceptedTerms", $$v)
                                      },
                                      expression: "form.acceptedTerms",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      color: "accent",
                                      flat: "",
                                      "aria-checked":
                                        _vm.form.acceptMarketingNews,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c("div", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "components.register.form.acceptMarketingNews"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.form.acceptMarketingNews,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "acceptMarketingNews",
                                          $$v
                                        )
                                      },
                                      expression: "form.acceptMarketingNews",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      color: "accent",
                                      "aria-checked": _vm.form.acceptedPolicy,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "components.register.form.acceptPolicy"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function (ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "a",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "register-important-link",
                                                                  attrs: {
                                                                    target:
                                                                      "_blank",
                                                                    href: _vm.toPolicyLink,
                                                                    "aria-label":
                                                                      "Read Privacy Policy",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                      },
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  "\n                            Learn More\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "components.register.form.acceptPolicyDialog"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.form.acceptedPolicy,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "acceptedPolicy",
                                          $$v
                                        )
                                      },
                                      expression: "form.acceptedPolicy",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-progress-linear", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isLoading,
                                expression: "isLoading",
                              },
                            ],
                            attrs: {
                              color: "accent",
                              indeterminate: "",
                              role: "status",
                              "aria-label": "Submitting form",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                type: "submit",
                                disabled: !(
                                  _vm.form.acceptedPolicy &&
                                  _vm.form.acceptedTerms
                                ),
                                "aria-label": _vm.$t(
                                  "components.oauthProfile.buttons.change"
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.oauthProfile.buttons.change"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }